import CircularProgress from '@mui/material/CircularProgress';
import clsx from 'clsx';
import queryString from 'query-string';
import React, { useEffect, useRef, useState } from 'react';
import { getProperties } from '../api';
import List from '../components/core/List';
import Wrapper from '../components/core/Wrapper';
import Filters from '../components/Modals/Filters';
import Pagination from '../components/Pagination/Pagination';
import { Property } from '../components/Property/Property';
import { handleGlobalApiCalls } from '../helpers/asyncActions';
//import { getFilterSearchObjFromQueryStr } from '../helpers/general';
import { useGlobalContext } from '../stores/global';
import PropertiesGoogleMap from '../components/PropertiesGoogleMap';
import stylesDesktop from './PropertiesDesktop.module.scss';
import styles from './Properties.module.scss';
import { PropertyNoBimmo } from '../components/PropertyNoBimmo/PropertyNoBimmo';
import {
  Box,
  FormControl,
  InputBase,
  Menu,
  MenuItem,
  NativeSelect,
} from '@mui/material';
import { createStyles, withStyles, Theme } from '@material-ui/core/styles';
import { Alert } from '@mui/material';
import SaveFilterDialog from '../components/SaveFilterDialog';

// TODO: On iOS, need to double click/tap on footer items and probably
// on any element in this page in order to trigger a click
const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      'label + &': {
        marginTop: theme.spacing(0),
      },
    },
    input: {
      borderRadius: 7,
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #bbb',
      fontSize: 14,
      [theme.breakpoints.up('md')]: {
        fontSize: 16,
      },
      padding: '14px 14px 14px 14px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      color: '#312d2c',
      // Use the system font instead of the default Roboto font.
      fontFamily: 'Poppins',
      '&:focus': {
        borderRadius: 4,
        borderColor: '#bbb',
      },
    },
  })
)(InputBase);

export default function Properties() {
  //Get dimension of screen
  const hasWindow = typeof window !== 'undefined';
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  const queryParams = queryString.parse(window.location.search);
  const [showFilter, setShowFilter] = useState(false);
  const [showMap, setShowMap] = useState(
    localStorage.getItem('map') === 'true' ? true : false
  );
  const [isMobile, setIsMobile] = useState(false);
  const draggerStartRef = useRef<any>(null);
  const draggerEndRef = useRef<any>(null);
  const touchEventOnDraggerRef = useRef(false);
  const isMapFullScreenRef = useRef(false);
  const listRef = useRef<HTMLDivElement>(null);
  const mapDivRef = useRef<HTMLDivElement>(null);
  const [limitPage, setLimitPage] = useState(Number(queryParams.limit || 20));
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [valueNotification, setValueNotification] = useState('Notificaciones');
  const open = Boolean(anchorEl);
  const [anchorElEdit, setAnchorElEdit] = React.useState(null);
  const [openNotification, setOpenNotification] = useState(false);
  const openEdit = Boolean(anchorElEdit);
  const { user, dispatch, isLoading } = useGlobalContext();
  const initialFiltersStr = queryString.parse(window.location.search)
    .filters as string;

  //const { searchStrValue } = getFilterSearchObjFromQueryStr();

  const cleanFilters = () => {
    window.location.href = '/properties';
  };

  const handleChange = (event: any) => {
    setLimitPage(parseInt(event.target.value));
    const qs = queryString.parse(window.location.search);
    const newQueryStr = queryString.stringify({
      ...qs,
      limit: parseInt(event.target.value),
    });

    window.location.href = `/properties?${newQueryStr}`;
  };

  useEffect(() => {
    const handleTouchMove = (e: any) => {
      if (touchEventOnDraggerRef.current) e.preventDefault();
    };

    // NOTE: Fix for viewport heights on mobile browsers.
    // Due to the nav bar showing/appearing, the vh is not
    // recalculated causing sometimes unexpected behavior, especially
    // with elements at the bottom
    const handleResize = () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);

      if (isMapFullScreenRef.current) {
        listRef.current!.style.transform = getTransform();
      }
    };

    handleResize();

    document.addEventListener('touchmove', handleTouchMove, {
      passive: false,
    });

    window.addEventListener('resize', handleResize);

    return () => {
      document.body.classList.remove('only-mobile-oh');
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('touchmove', handleTouchMove, {
        passive: false,
      } as any);
    };
  }, []);

  const getTransform = (y: number = 0) => {
    if (isMapFullScreenRef.current) {
      return `translateY(calc(calc(var(--vh, 1vh) * 100) - ${
        getComputedStyle(listRef.current!).top
      } - 210px + ${window.scrollY + y}px))`;
    }

    return `translateY(${y}px)`;
  };

  const triggerFullScreenMap = (isFullScreen = true) => {
    listRef.current!.style.transition =
      'transform 0.4s cubic-bezier(0.35, 0, 0.65, 1) 0s';
    isMapFullScreenRef.current = isFullScreen;

    if (isFullScreen) {
      document.body.classList.add('only-mobile-oh');
    } else {
      document.body.classList.remove('only-mobile-oh');
    }

    listRef.current!.style.transform = getTransform();
  };

  const handleDraggerStart = (e: React.TouchEvent<HTMLDivElement>) => {
    touchEventOnDraggerRef.current = true;
    draggerStartRef.current = { y: e.touches[0].pageY };
  };
  const handleDraggerEnd = () => {
    touchEventOnDraggerRef.current = false;
    const y = draggerEndRef.current?.y ?? 0;

    if (isMapFullScreenRef.current) {
      if (y < -50) {
        triggerFullScreenMap(false);
      } else {
        listRef.current!.style.transform = getTransform();
      }
    } else {
      if (y < 0) {
        listRef.current!.style.transform = '';
        window.scroll(0, window.scrollY - y);
      } else if (y < 50) {
        listRef.current!.style.transform = '';
      } else {
        triggerFullScreenMap();
      }
    }
  };
  const handleDraggerMove = (e: React.TouchEvent<HTMLDivElement>) => {
    const y = e.touches[0].pageY;
    const newY = -(draggerStartRef.current.y - y);

    draggerEndRef.current = { y: newY };

    if (listRef.current!.style.transform) {
      listRef.current!.style.transform.substring;
    }

    listRef.current!.style.transition = '';
    listRef.current!.style.transform = getTransform(newY);
  };

  const handleDraggerMouseDown = () => {
    if (isMapFullScreenRef.current) {
      triggerFullScreenMap(false);
    }
  };

  //Renderizar celular o pc
  useEffect(() => {
    if (hasWindow) {
      if (getWindowDimensions().width > 768) setIsMobile(false);
      else setIsMobile(true);
      function handleResize() {
        if (getWindowDimensions().width > 768) setIsMobile(false);
        else setIsMobile(true);
      }

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, [hasWindow]);

  useEffect(() => {
    localStorage.setItem('map', showMap.toString());
  }, [showMap]);

  //Notificacion select
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (value: string) => {
    if (value === 'Nueva') {
      setShowFilter(true);
    } else {
      setValueNotification(value);
    }

    setAnchorEl(null);
  };

  const handleCloseBackDrop = () => {
    setAnchorEl(null);
  };

  const handleClickEdit = (event: any) => {
    setAnchorElEdit(event.currentTarget);
  };
  const handleCloseEdit = (value: number) => {
    if (value === 1) {
      setShowFilter(true);
    } else {
      /*       console.log('entro aca'); */
      setOpenNotification(true);
    }
    setAnchorElEdit(null);
  };

  const handleCloseBackDropEdit = () => {
    setAnchorElEdit(null);
  };

  return (
    <Pagination
      apiFn={getProperties}
      propsLimit={limitPage}
      render={(
        properties,
        isLoadingContent,
        error,
        paginationEl,
        avgPrices
      ) => (
        <>
          {!isMobile ? (
            <>
              <div className={stylesDesktop.filters}></div>
              <div
                className={clsx(
                  stylesDesktop.content,
                  showMap && stylesDesktop.mapIsShown
                )}
              >
                {isLoadingContent ? (
                  <CircularProgress style={{ marginTop: 30, marginLeft: 20 }} />
                ) : !!error ? (
                  <p style={{ marginTop: 30, marginLeft: 20 }}>
                    Ocurrió un error. Inténtalo más tarde
                  </p>
                ) : properties?.length === 0 ? (
                  <p style={{ marginTop: 30, marginLeft: 20 }}>
                    No hay propiedades, Intente cambiar los filtros.
                    <br />
                    <a
                      onClick={cleanFilters}
                      style={{
                        float: 'left',
                        color: 'var(--primaryColorLight)',
                        textDecoration: 'none',
                      }}
                    >
                      Borrar todos los filtros
                    </a>
                  </p>
                ) : (
                  <>
                    <div className={stylesDesktop.roundedTriangleL} />
                    <div className={stylesDesktop.roundedTriangleR} />
                    <button
                      className={stylesDesktop.mapBtnX}
                      onClick={() => setShowMap(false)}
                    >
                      <i className="fonticons fonticons-x" />
                    </button>

                    <div className={stylesDesktop.map} ref={mapDivRef}>
                      {showMap && (
                        <PropertiesGoogleMap
                          mapDivRef={mapDivRef}
                          properties={showMap ? properties! : []}
                          onClick={triggerFullScreenMap}
                          onDrag={triggerFullScreenMap}
                          avgPrices={showMap ? avgPrices : []}
                        />
                      )}
                    </div>

                    <div className={stylesDesktop.listContainer} ref={listRef}>
                      <div className={stylesDesktop.buttonContainer}>
                        <button
                          onClick={(e) =>
                            valueNotification === 'Notificaciones'
                              ? setShowFilter(true)
                              : handleClickEdit(e)
                          }
                        >
                          <i className="fonticons fonticons-filter" />
                          <span>
                            &nbsp;{' '}
                            {valueNotification === 'Notificaciones'
                              ? 'Filtros'
                              : 'Editar'}
                          </span>
                        </button>
                        <Menu
                          id="basic-menu"
                          anchorEl={anchorElEdit}
                          className={stylesDesktop.menu_dropdown}
                          open={openEdit}
                          onClose={handleCloseBackDropEdit}
                          MenuListProps={{
                            'aria-labelledby': 'basic-button',
                          }}
                        >
                          <MenuItem onClick={() => handleCloseEdit(1)}>
                            Filtros
                          </MenuItem>
                          <MenuItem onClick={() => handleCloseEdit(2)}>
                            Notificaciones
                          </MenuItem>
                        </Menu>
                        <button
                          className={stylesDesktop.buttonSecond}
                          onClick={handleClick}
                        >
                          <i className="fonticons fonticons-alerts" />
                          &nbsp; {valueNotification}
                        </button>
                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          className={stylesDesktop.menu_dropdown}
                          open={open}
                          onClose={handleCloseBackDrop}
                          MenuListProps={{
                            'aria-labelledby': 'basic-button',
                          }}
                        >
                          <MenuItem onClick={() => handleClose('Nueva')}>
                            Nueva Notificación +
                          </MenuItem>
                          <MenuItem onClick={() => handleClose('Barranquilla')}>
                            Barranquilla
                          </MenuItem>
                          <MenuItem
                            onClick={() =>
                              handleClose('Villa Santos Apartamento')
                            }
                          >
                            Villa Santos Apartamento
                          </MenuItem>
                          <MenuItem
                            onClick={() => handleClose('Barrio Abajo Baratos')}
                          >
                            Barrio Abajo Baratos
                          </MenuItem>
                        </Menu>
                        <button onClick={() => setShowMap((prev) => !prev)}>
                          <i className="fonticons fonticons-pin" />
                          &nbsp; Mapa
                        </button>
                        <Box className={styles.box}>
                          <FormControl className={styles.formControl}>
                            <NativeSelect
                              id="demo-customized-select-native"
                              value={limitPage}
                              onChange={handleChange}
                              input={<BootstrapInput />}
                            >
                              <option value="20">Ver 20 propiedades</option>
                              <option value="50">Ver 50 propiedades</option>
                              <option value="100">Ver 100 propiedades</option>
                            </NativeSelect>
                          </FormControl>
                        </Box>
                      </div>
                      <List
                        className={stylesDesktop.list}
                        prepend={
                          <div
                            onTouchMove={handleDraggerMove}
                            onTouchStart={handleDraggerStart}
                            onTouchEnd={handleDraggerEnd}
                            onMouseDown={handleDraggerMouseDown}
                            onClick={handleDraggerMouseDown}
                            className={stylesDesktop.dragger}
                          />
                        }
                      >
                        {properties?.map((item: any) =>
                          item && !item.idWebSite ? (
                            <Property key={item.id} property={item} />
                          ) : (
                            item && (
                              <PropertyNoBimmo
                                key={item.id}
                                property={item}
                                avgPrices={avgPrices}
                              />
                            )
                          )
                        )}
                      </List>
                      {paginationEl}
                    </div>
                  </>
                )}

                <Filters
                  open={showFilter}
                  initialFilterStr={initialFiltersStr}
                  onClose={() => setShowFilter(false)}
                  onCleanFilters={cleanFilters}
                  onSubmit={(filterJson) =>
                    handleGlobalApiCalls(dispatch, isLoading, null, () => {
                      dispatch({ type: 'SET_LOADING', payload: true });
                      const qs = queryString.parse(window.location.search);
                      const newQueryStr = queryString.stringify({
                        ...qs,
                        limit: undefined,
                        page: undefined,
                        filters: JSON.stringify({
                          ...(typeof qs.filters === 'string'
                            ? JSON.parse(qs.filters)
                            : {}),
                          ...filterJson,
                        }),
                      });

                      window.location.href = `/properties?${newQueryStr}`;
                      return Promise.resolve();
                    })
                  }
                />
                <SaveFilterDialog
                  open={openNotification}
                  onClose={() => setOpenNotification(false)}
                />
              </div>
            </>
          ) : (
            <Wrapper
              contentProps={{
                className: clsx(styles.content, showMap && styles.mapIsShown),
              }}
              subHeader={{
                title: '',
                right: (
                  <select
                    className={styles.selectView}
                    value={limitPage}
                    onChange={handleChange}
                  >
                    <option value="20">Ver 20 propiedades</option>
                    <option value="50">Ver 50 propiedades</option>
                    <option value="100">Ver 100 propiedades</option>
                  </select>
                ),
                left: (
                  <a
                    className={styles.filterItemRight}
                    onClick={() => setShowFilter(true)}
                  >
                    <span>Filtros</span>
                    <i className="fonticons fonticons-filter" />
                  </a>
                ),
                props: { className: styles.subHeader },
              }}
            >
              {isLoadingContent ? (
                <CircularProgress style={{ marginTop: 30, marginLeft: 20 }} />
              ) : !!error ? (
                <p style={{ marginTop: 30, marginLeft: 20 }}>
                  Ocurrió un error. Inténtalo más tarde
                </p>
              ) : properties?.length === 0 ? (
                <p style={{ marginTop: 30, marginLeft: 20 }}>
                  No hay propiedades, Intente cambiar los filtros.
                  <br />
                  <a
                    onClick={cleanFilters}
                    style={{
                      float: 'left',
                      color: 'var(--primaryColorLight)',
                      textDecoration: 'none',
                    }}
                  >
                    Borrar todos los filtros
                  </a>
                </p>
              ) : (
                <>
                  <div className={styles.roundedTriangleL} />
                  <div className={styles.roundedTriangleR} />

                  <button
                    className={styles.mapBtn}
                    onClick={() => setShowMap(true)}
                  >
                    <i className="fonticons fonticons-pin" />
                    Mapa
                  </button>
                  <button
                    className={styles.mapBtnX}
                    onClick={() => setShowMap(false)}
                  >
                    <i className="fonticons fonticons-x" />
                  </button>

                  <div className={styles.map} ref={mapDivRef}>
                    <PropertiesGoogleMap
                      mapDivRef={mapDivRef}
                      properties={properties!}
                      onClick={triggerFullScreenMap}
                      onDrag={triggerFullScreenMap}
                      avgPrices={avgPrices}
                    />
                  </div>
                  <div className={styles.listContainer} ref={listRef}>
                    {!user?.name && (
                      <Alert
                        style={{ marginBottom: '10px', fontSize: '14px' }}
                        severity="info"
                      >
                        <strong>Inicia sesión</strong> para ver toda la
                        información
                      </Alert>
                    )}

                    <List
                      className={styles.list}
                      prepend={
                        <div
                          onTouchMove={handleDraggerMove}
                          onTouchStart={handleDraggerStart}
                          onTouchEnd={handleDraggerEnd}
                          onMouseDown={handleDraggerMouseDown}
                          onClick={handleDraggerMouseDown}
                          className={styles.dragger}
                        />
                      }
                    >
                      {properties?.map((item: any) =>
                        item && !item.idWebSite ? (
                          <Property key={item.id} property={item} />
                        ) : (
                          item && (
                            <PropertyNoBimmo
                              key={item.id}
                              property={item}
                              avgPrices={avgPrices}
                            />
                          )
                        )
                      )}
                    </List>
                    {paginationEl}
                  </div>
                </>
              )}

              <Filters
                open={showFilter}
                initialFilterStr={initialFiltersStr}
                onClose={() => setShowFilter(false)}
                onCleanFilters={cleanFilters}
                onSubmit={(filterJson) =>
                  handleGlobalApiCalls(dispatch, isLoading, null, () => {
                    dispatch({ type: 'SET_LOADING', payload: true });
                    const qs = queryString.parse(window.location.search);
                    const newQueryStr = queryString.stringify({
                      ...qs,
                      limit: undefined,
                      page: undefined,
                      filters: JSON.stringify({
                        ...(typeof qs.filters === 'string'
                          ? JSON.parse(qs.filters)
                          : {}),
                        ...filterJson,
                      }),
                    });

                    window.location.href = `/properties?${newQueryStr}`;
                    return Promise.resolve();
                  })
                }
              />
              <SaveFilterDialog
                open={openNotification}
                onClose={() => setOpenNotification(false)}
              />
            </Wrapper>
          )}
        </>
      )}
    />
  );
}
